exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-container[data-v-35e788d9] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px 0;\n}\n.search-container .search-component[data-v-35e788d9] {\n    width: 270px;\n}\n.search-container .search-component .search-box[data-v-35e788d9] {\n      -webkit-box-pack: start;\n          -ms-flex-pack: start;\n              justify-content: flex-start;\n}\n.search-container .filter-container[data-v-35e788d9] {\n    margin-left: auto;\n}\n", ""]);

// exports
